import {
    GET_USER_DATA,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_ERROR,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
} from '../types';
//Cookie
import messages from '../constants/messages';
import api from '../helpers/api';
import apiMethods from '../constants/apiMethods';
import { isJwtTokenStored } from '../helpers/authHelper';
import cookieHelper from '../helpers/cookieHelper';
//Get user data
export function getUserDataAction(history) {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( getUserData() );
        //Verifico que exista el token
        if(isJwtTokenStored()){
            //Ejecuto la consutla
            try{
                //Cargo la espera
                // alertMessages.waiting(messages.LOADING.USER_DATA);
                const response = await api.get(apiMethods.USER_DATA);
                //Obtengo los datos
                const res = response.data;
                //Llamo al success
                dispatch( getUserDataSuccess(res.data) );
            }catch(error){
                const response = error.response;
                let data = {
                    data: null,
                    message: messages.ERROR.SERVER
                };
                //Verifico si hay error
                if(response){
                    data = response.data;
                }
                //Llamo al dispatch
                dispatch( getUserDataError(data) );
            }
        }
    }
}

const getUserData = () => ({
    type: GET_USER_DATA,

})

const getUserDataSuccess = user => ({
    type: GET_USER_DATA_SUCCESS,
    payload: user
})

const getUserDataError = error => ({
    type: GET_USER_DATA_ERROR,
    payload: error
})

//Logout
export function logoutAction() {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( logout() );
        //Elimino la cookie
        cookieHelper.remove(process.env.REACT_APP_TN, {path: '/'});
        //Llamo al success
        dispatch( logoutSuccess() );
        //Redirecciono
        window.location = process.env.REACT_APP_LOGOUT_URL;
    }
}

const logout = () => ({
    type: LOGOUT_USER,

})
//Si el category se guarda ok
const logoutSuccess = () => ({
    type: LOGOUT_USER_SUCCESS,
    payload: null
})